export default function Footer() {
  return (
   <footer className="bg-[#0d1b2a] text-white py-10">
  <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-start gap-10">

    {/* FAQ */}
    <div>
      <h3 className="text-xl font-semibold mb-4">FAQ</h3>
      <ul className="space-y-2 text-gray-300">
        <li><a href="/faq#services" className="hover:text-white">What services do you offer?</a></li>
        <li><a href="/faq#pricing" className="hover:text-white">Do you provide pricing plans?</a></li>
        <li><a href="/faq#support" className="hover:text-white">How can I contact support?</a></li>
      </ul>
    </div>
    {/* Copyright + Designed By */}
    <div className="text-left md:text-right">
      <p className="text-gray-400">
        © {new Date().getFullYear()} HaatarKaj.com. All Rights Reserved.
      </p>
      <p className="text-gray-400 text-sm text-center">
        Designed by <span className="text-white font-semibold">Codexa</span>
      </p>
    </div>
    {/* Social Links */}
    <div>
      <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
      <ul className="space-y-2 text-gray-300">
        <li>
          <a
            href="https://www.facebook.com/share/17u187kwMQ/"
            target="_blank"
            className="hover:text-blue-400"
          >
            Facebook
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/haat_ka_kaam?igsh=MTZiOXFhYWU1cHF2cg=="
            target="_blank"
            className="hover:text-pink-400"
          >
            Instagram
          </a>
        </li>
        <li>
          
            Email-contact_us@haaterkaj.com
         
        </li>
      </ul>
    </div>

    

  </div>
</footer>


  );
}
